module.exports = __webpack_public_path__ + "img/background_c3-1.6e3e3b6b.jpg";